import { Form } from 'factorial-form'

import { stringToDate } from 'modules/core/lib/dates'

import { DurationUnit } from 'modules/timeoff/lib/BlockedPeriods/TimePeriod'
import type { ITimePeriod as TimePeriodAttributes } from 'modules/timeoff/lib/BlockedPeriods/TimePeriod'

class TimePeriodForm extends Form {
  constructor(
    values: TimePeriodAttributes = {
      name: '',
      periodType: 'by_time_range',
      durationUnit: DurationUnit.months,
      _destroy: false,
    }
  ) {
    super(
      { ...values },
      {
        id: 'string',
        name: 'string',
        periodType: 'string',
        duration: 'number',
        durationUnit: 'string',
        startOn: 'date',
        finishOn: 'date',
        _destroy: 'boolean',
      }
    )
  }

  get isValid() {
    if (!!this.get('name').value && !!this.get('periodType').value) {
      if (this.byTimeRange) {
        return !!this.get('startOn').value && !!this.get('finishOn').value
      } else if (this.byContractStartDate) {
        return !!this.get('duration').value && !!this.get('durationUnit').value
      }
    }
    return false
  }

  get byContractStartDate() {
    return this.get('periodType').value == 'by_contract_start_date'
  }

  get byTimeRange() {
    return this.get('periodType').value == 'by_time_range'
  }

  get startOn() {
    return stringToDate(this.get('startOn').value, 'ui')
  }
}

export default TimePeriodForm
